// extracted by mini-css-extract-plugin
export default {"header":"JournalToolbar_header__YwYtJ","title":"JournalToolbar_title__SwrYt","muted":"JournalToolbar_muted__dZYfS","actions":"JournalToolbar_actions__Q5eEz"};